<template>
  <div>
    <span class="integer-context">{{ calInteger }}</span
    >.<span class="decimal-context">{{ calDecimal }}</span>
  </div>
</template>

<script>
import splitThousands from '@/util/splitThousands';

export default {
  name: 'EquityNumber',
  props: {
    value: {
      type: Number | String,
      default: 0,
    },
    fixed: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    calFixed() {
      return this.fixed;
    },
    calValue() {
      if (Number(this.value) >= 0) {
        return splitThousands(this.value, this.calFixed);
      }
      return null;
    },
    calInteger() {
      return this.calValue !== null ? this.calValue.split('.')[0] : '0.00';
    },
    calDecimal() {
      return this.calValue !== null ? this.calValue.split('.')[1] : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.integer-context {
  font-size: 24px;
  font-weight: 600;
}
.decimal-context {
  font-size: 18px;
  font-weight: 600;
}

@media (max-width: 768px) {
  .integer-context {
    font-size: 14px;
  }
  .decimal-context {
    font-size: 11px;
  }
}
</style>
